document.addEventListener('DOMContentLoaded', function() {

  // --- Lookup page: search by lot number ---
  var submitBtn = document.querySelector('.lot-input-btn');
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {

      var query = document.querySelector('.lot-input-search').value.toLowerCase();
      var resultsContainer = document.getElementById('lot-results');
      resultsContainer.innerHTML = '';

      var matches = lotdata[0].lot_numbers.filter(function(item) {
        return item.lotnumber.toLowerCase() === query;
      });

      if (matches.length === 0) {
        resultsContainer.classList.remove('has-results');
        resultsContainer.innerHTML = '<div class="selected-lot-noresults"><p>No results found</p></div>';
      } else {

        resultsContainer.classList.add('has-results');
        matches.forEach(function(item) {

          var aster, lotinfo;
          if (item.yearly == 'true') {
            aster = '<sup>*</sup>';
            lotinfo = yearlydisctextAlt;
          } else {
            aster = '';
            lotinfo = 'The lot containing ' + item.product_name + ', ' + disctextAlt;
          }

          resultsContainer.insertAdjacentHTML('beforeend',
            '<div class="selected-lot">' +
            '<div class="lot-title"><h3>' + item.product_name + aster + '</h3></div>' +
            '<div class="lot-info">' + lotinfo + '</div>' +
            '<div class="lot-results-label">Results</div>' +
            '<table class="lot-table">' +
              '<thead>' +
                '<tr>' +
                  '<th>Metal</th>' +
                  '<th>' +
                    '<div>FoodNerd</div>' +
                    '<div class="subTitle">Test results for this lot</div>' +
                  '</th>' +
                  '<th>' +
                    '<div>California Prop 65</div>' +
                    '<div class="subTitle">Max Daily Allowable Level</div>' +
                  '</th>' +
                '</tr>' +
              '</thead>' +
              '<tbody>' +
                '<tr>' +
                  '<td class="metal">Lead</td>' +
                  '<td>' +
                    '<div>' + item.lead + '</div>' +
                    '<div class="ppm">' + item.lead_ppm + '</div>' +
                  '</td>' +
                  '<td>0.5 mcg</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="metal">Cadmium</td>' +
                  '<td>' +
                    '<div>' + item.cadmium + '</div>' +
                    '<div class="ppm">' + item.cadmium_ppm + '</div>' +
                  '</td>' +
                  '<td>4.1 mcg</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="metal">Arsenic</td>' +
                  '<td>' +
                    '<div>' + item.arsenic + '</div>' +
                    '<div class="ppm">' + item.arsenic_ppm + '</div>' +
                  '</td>' +
                  '<td>10 mcg</td>' +
                '</tr>' +
                '<tr>' +
                  '<td class="metal">Mercury</td>' +
                  '<td>' +
                    '<div>' + item.mercury + '</div>' +
                    '<div class="ppm">' + item.mercury_ppm + '</div>' +
                  '</td>' +
                  '<td>0.3 mcg</td>' +
                '</tr>' +
              '</tbody>' +
            '</table>' +
            '</div>'
          );
        });
      }

    });
  }


  // --- Test results page: show all lots in table ---
  function renderTestResults() {

    if (typeof yearlydisctextAlt !== 'undefined') {
      var disclaimer = document.querySelector('.footer-disclaimer');
      if (disclaimer) {
        disclaimer.insertAdjacentHTML('afterbegin', '<p><sup>*</sup>' + yearlydisctextAlt + '</p>');
      }
    }

    var resultsBody = document.querySelector('#test-results .results-table tbody');
    if (!resultsBody) return;

    var lotNumbers = lotdata[0].lot_numbers;

    lotNumbers.forEach(function(item) {

      var aster = (item.yearly == 'true') ? '<sup>*</sup>' : '';

      resultsBody.insertAdjacentHTML('beforeend',
        '<tr>' +
          '<td>' + item.lotnumber + aster + '</td>' +
          '<td>' + item.testdate + '</td>' +
          '<td>' + item.product_name + '</td>' +
          '<td>' +
            '<div>' + item.lead + '</div>' +
            '<div class="ppm">' + item.lead_ppm + '</div>' +
          '</td>' +
          '<td>' +
            '<div>' + item.cadmium + '</div>' +
            '<div class="ppm">' + item.cadmium_ppm + '</div>' +
          '</td>' +
          '<td>' +
            '<div>' + item.arsenic + '</div>' +
            '<div class="ppm">' + item.arsenic_ppm + '</div>' +
          '</td>' +
          '<td>' +
            '<div>' + item.mercury + '</div>' +
            '<div class="ppm">' + item.mercury_ppm + '</div>' +
          '</td>' +
        '</tr>'
      );

    });

  }

  // Check if we're on the test results page
  var testResultsEl = document.getElementById('test-results');
  if (testResultsEl && typeof lotdata !== 'undefined') {
    renderTestResults();
  }


});